import styled from "styled-components/macro";
import { editorContentStyles } from "./editorContentStyles";

export const BackgroundContainer = styled.div`
  background: var(--body-background);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: calc(100vw + 24px);
  height: calc(100vh + 24px);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
  z-index: 99995;
`;

export const EditorContainerContainer = styled.div`
  position: relative;
  overflow: visible;

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
  }

  .editor-container-wrapper {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding-bottom: ${(props) => (props.showThumbs ? "70px" : "0")};

    &.hidden {
      display: none;
    }
  }

  .background {
  }

  .open-focus,
  .close-focus {
    position: absolute;
    width: 35px;
    top: 6px;
    right: 4px;
    transform: rotate(90deg);
    z-index: 1;

    svg {
      vertical-align: middle;
      path {
        fill: var(--grey-2);
      }
    }
  }

  .close-focus {
    z-index: 200000;
  }

  /* The iframe that displays the actual editor */
  #editorContainer {
    overflow-y: auto;
    order: 1;
    font-size: 20px;
    font-family: Quattro, Courier New;
    padding: 0;
    width: calc(100%);
    border-radius: 0 15px 0 0;
    scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);

    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background: var(--scrollbar-track);
    }
    &::-webkit-scrollbar-thumb {
      background-color: var(--scrollbar-thumb);
      border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: var(--scrollbar-thumb-hover);
    }

    &.disabled {
      pointer-events: none !important;
    }
  }

  /* When comment sidebar is visible, remove iframe's top-right radius */
  .editor-container-wrapper.has-comments #editorContainer {
    border-radius: 0;
  }

  @keyframes dismiss {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
      display: none;
    }
  }

  .overlay-wrapper {
    &.dismissed {
      animation: dismiss 0.25s ease-out 1;
      animation-fill-mode: forwards;
    }
  }

  .overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: var(--focus-overlay-background);
    z-index: 200000;
  }

  @keyframes up-down {
    0% {
      transform: translate(-50%, -50%);
    }

    50% {
      transform: translate(-50%, -50%) translateY(-25px);
    }

    100% {
      transform: translate(-50%, -50%);
    }
  }

  .relax {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 200002;
    transform: translate(-50%, -50%);
    /* padding: 15px 95px; */
    padding: 15px 0;
    width: 475px;
    font-size: 18px;
    border-radius: 25px;
    background: white;
    border: 1px solid #ccc;
    animation: up-down 1s linear 1;
    animation-delay: 1.5s;
    animation-fill-mode: forwards;
  }

  @keyframes down-up {
    0% {
      transform: translate(-50%, -50%);
    }

    50% {
      transform: translate(-50%, -50%) translateY(+25px);
    }

    95% {
      z-index: 200003;
    }

    100% {
      transform: translate(-50%, -50%);
      z-index: 200003;
    }
  }

  .esc {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 200000;
    transform: translate(-50%, -50%);
    padding: 15px 0;
    font-size: 18px;
    border-radius: 25px;
    width: 475px;
    background: black;
    color: white;
    border: 1px solid #ccc;
    animation: down-up 1s linear 1;
    animation-delay: 1.5s;
    animation-fill-mode: forwards;
  }

  &.focus {
    padding: 0px 0 35px 5px;
    background: var(--document-background);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0;
    border: 0;
    border-radius: 0;
    height: 100% !important;
    text-align: center;
    z-index: 199999999;

    #editorContainer {
      width: calc(100% - 50px);
      max-width: 900px;
      height: 100% !important;
      border-radius: 0;
      border: 0;
      box-shadow: none;
      background: none;
    }
  }

  .like-container {
    position: absolute;
    bottom: 10px;
    right: 25px;
  }

  ${editorContentStyles}

  @media print {
    &.project-print-shell {
      position: static !important;
      display: block !important;
      width: 100% !important;
      height: auto !important;
      margin: 0 !important;
      padding: 0 !important;
      color: #111 !important;
      background: #fff !important;
      border: 0 !important;
      text-align: left;

      .project-print-document-title {
        max-width: none;
        margin: 0 0 0.65em;
        padding: 0 0 0.35em;
        color: #111;
        border-bottom: 1px solid #d8d8d8;
        font-size: 24pt;
        font-weight: 700;
        line-height: 1.15;
        overflow-wrap: anywhere;
        break-after: avoid;
      }

      #editorContainer {
        position: static;
        isolation: auto;
        display: block;
        width: 100%;
        min-height: 0;
        height: auto;
        margin: 0;
        padding: 0;
        overflow: visible;
        border: 0;
        border-radius: 0;
        background: #fff;
      }

      #editor {
        position: static;
        display: block;
        width: 100%;
        min-height: 0;
        height: auto;
        overflow: visible;
        color: #111;
        background: #fff;
        z-index: auto;
      }

      #editorContainer .ProseMirror {
        position: static;
        width: 100%;
        min-height: 0;
        height: auto;
        margin: 0;
        padding: 0;
        overflow: visible;
        color: #111 !important;
        background: #fff !important;
        z-index: auto;
      }

      #editor .ProseMirror > h1,
      #editor .ProseMirror > h2,
      #editor .ProseMirror > h3,
      #editor .ProseMirror > h4,
      #editor .ProseMirror > h5 {
        break-after: avoid;
      }

      #editor .ProseMirror > p,
      #editor .ProseMirror li {
        orphans: 3;
        widows: 3;
      }

      #editor img {
        max-width: 100%;
        height: auto;
        break-inside: avoid;
      }

      #editor .sudo-agent-edit-highlight,
      #editor .sudo-persisted-selection,
      #editor .search-result,
      #editor .search-result-selected,
      #editor span[data-annotation-id] {
        color: inherit !important;
        background: transparent !important;
        border-color: transparent !important;
        box-shadow: none !important;
        outline: 0 !important;
      }

      #editor .spell-error,
      #editor .grammar-error {
        text-decoration: none !important;
      }

      #editor p.is-editor-empty:first-child::before {
        content: none;
      }
    }
  }
`;

export const EditorHeaderContainer = styled.div`
  padding: 0 40px;
  margin-top: 22px;
  display: flex;
  align-items: center;

  .linking-menu-button {
    svg {
      circle {
        fill: var(--grey-0);
      }
    }
  }
`;
